import { NgModule } from "@angular/core";
import { ApiResourceModule } from "../../apiResource/apiResource.module";
import { SamResourceService } from "./samResource.service";
import { CacheSamResourceService } from "./cache-sam-resource.service";

@NgModule({
    imports: [
        ApiResourceModule,
    ],
    providers: [
        SamResourceService,
        CacheSamResourceService
    ]
})
export class SamResourceModule {
}